import { createContext, useContext } from "react";
import { useOfflineSync } from "./useOfflineSync";

const Ctx = createContext(null);

// Single global instance of the sync engine so auto-sync runs on every route
// (including /receipt/*), not only inside Layout.
export function OfflineSyncProvider({ children }) {
  const state = useOfflineSync();
  return <Ctx.Provider value={state}>{children}</Ctx.Provider>;
}

export const useOfflineSyncState = () => useContext(Ctx);
